import {atom} from 'recoil';

export const currentTestState = atom({
    key: 'currentTestState',
    default: {}
});

export const lessonTypeState = atom({
    key: 'lessonTypeState',
    default: 0
});

export const testTypeState = atom({
    key: 'testTypeState',
    default: 0
});

export const numberOfQuestionState = atom({
    key: 'numberOfQuestionState',
    default: 0
});

export const currentQuestionIndexState = atom({
    key: 'currentQuestionIndexState',
    default: 1
});

export const numberOfRootQuestionState = atom({
    key: 'numberOfRootQuestionState',
    default: 0
});

//student answers
export const answersState = atom({
    key: 'answersState',
    default: []
});

export const currentQuestionState = atom({
    key: 'currentQuestionState',
    default: 0
});

export const nextAbleQuestionsState = atom({
    key: 'nextAbleQuestionsState',
    default: []
});